import './Career.scss';
import careerImg from '../assets/career.png';
import desingerImg from '../assets/desinger.png';
import { Stack, Accordion, Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import ScrollToTop from '../components/ScrollToTop';

function Career({ setactivelink }) {

    return (
        <Stack setactivelink={setactivelink} id="career" gap={6} className="career">
            <ScrollToTop />
            <Container className="py-4">

                <h1 className="section-title">Current Job Openings</h1>

                <Row className="mt-4">
                    <Col sm={12}>
                        <h5>🚀 <span className="section-subtitle">Why Join Cube Tech Studio?</span></h5>
                    </Col>
                    <Col md={6}>
                        <ul className='my-md-1 mb-0'>
                            <li>Creative & Collaborative Environment</li>
                            <li>Work on Diverse Projects</li>
                            <li>Learn New Tools & Technologies</li>
                            <li>Opportunity to Work with Real Brands</li>
                        </ul>
                    </Col>
                    <Col md={6}>
                        <ul className='my-md-1  my-0'>
                            <li>Career Growth Opportunities</li>
                            <li>Friendly & Supportive Team</li>
                            <li>Hands-on Experience Across Digital & Creative Projects</li>
                        </ul>
                    </Col>
                </Row>

                <Accordion className="my-4">
<Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <div>
                                <h4>Marketing Executive / Digital Marketing Specialist</h4>
                                <h6>Experience: 3+ Years <span className="mx-3">|</span> Job Type: Full-time <span className="mx-3">|</span> Location: Pune</h6>
                                <p>We’re looking for a proactive and result-oriented Marketing Executive / Digital
                                    Marketing Specialist who can manage both online and offline marketing, generate new business
                                    opportunities, and build strong client relationships.</p>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <section>
                                <div className="row align-items-center gy-4">
                                    <div className="col-lg-12">
                                        <div className="job-details">
                                            <Row className="border-bottom mb-3 py-3">
                                                <Col md={12}>
                                                    <h4>What You’ll Do</h4>
                                                </Col>
                                                <Col md={6}>
                                                    <ul>
                                                        <li>Plan and execute <b>online & offline marketing campaigns</b> across social media and digital platforms.</li>
                                                        <li>Manage <b>social media marketing, lead generation, and audience engagement.</b></li>
                                                        <li>Generate leads for <b>website, mobile app, branding, and digital marketing services.</b></li>
                                                        <li>Meet clients, understand their requirements, present services, and build relationships.</li>

                                                    </ul>
                                                </Col>
                                                <Col md={6}>
                                                    <ul>
                                                        <li>Follow up with prospects and <b>convert leads into clients.</b></li>
                                                        <li>Develop creative marketing ideas to increase brand visibility and business growth.</li>
                                                        <li>Coordinate with internal design and development teams.</li>
                                                        <li>Track leads, campaigns, conversions, and marketing performance.</li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                            <Row className="border-bottom mb-3 py-3">
                                                <Col lg={8}>
                                                    <h4>What We’re Looking For</h4>
                                                    <ul className="my-3">
                                                        <li>Experience in <b>online & offline marketing</b>.</li>
                                                        <li>Knowledge of <b>Social Media, Meta Ads, Google Ads & Lead Generation</b>.</li>
                                                        <li>Strong <b>communication, presentation, negotiation, and follow-up</b> skills.</li>
                                                        <li>Understanding of <b>Website & Mobile App Design and Development</b>.</li>
                                                        <li>Confident, creative, self-motivated, and <b>target-oriented</b>.</li>
                                                        <li>Willingness to <b>travel for client meetings and business development.</b></li>
                                                    </ul>
                                                    <h5>Added Advantage</h5>
                                                    <ul>
                                                        <li>Experience in an IT / Web / Digital Agency.</li>
                                                        <li>B2B sales or marketing experience.</li>
                                                        <li>Existing business network or client connections.</li>
                                                        <li>Knowledge of CRM and marketing analytics tools.</li>
                                                        <li>Own vehicle or willingness to travel.</li>
                                                    </ul>
                                                </Col>
                                                <Col lg={4}>
                                                    <img src={careerImg} width="100%" alt="career" />
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-end mt-2">
                                                <Col sm="12">
                                                    <div className="d-grid gap-2">
                                                        <Link to="/career/pre-interview-form" className="btn btn-danger">Apply Now</Link>
                                                    </div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </div>
                                </div>
                            </section>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header> <div><h4>Graphic, Web, UI Designer</h4>
                            <h6>Vacancy for Fresher & Intern only  (Artist Background)<span className="mx-3">|</span> Job Type: Full-time <span className="mx-3">|</span> Location: Pune</h6>
                            <p className="me-3">  We are looking for a creative Graphic, Web, UI Designer who can transform ideas and business requirements into modern, user-friendly and visually engaging websites, digital, social media, branding and print requirements.
                            </p>
                        </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="row align-items-center gy-4">
                                <div className="col-lg-12">
                                    <div className="job-details">
                                        <p>
                                            You will work closely with our design, development and digital marketing teams to create responsive websites and digital experiences for a variety of clients.
                                        </p>

                                        <div className="py-2">
                                            <h4>What You’ll Do</h4>
                                            <Row className="border-bottom mb-3">
                                                <Col lg={7}>
                                                    <ul className="mb-2">
                                                        <li>Create social media creatives, banners and advertisements.</li>
                                                        <li>Maintain brand consistency across designs.</li>
                                                        <li>Design modern, responsive websites and landing pages.</li>
                                                        <li>Create UI/UX designs, wireframes and prototypes.</li>
                                                        <li>Work with developers to implement designs.</li>
                                                        <li>Ensure excellent visual quality and user experience.</li>
                                                        <li>Design branding, brochures, flyers and marketing materials.</li>
                                                        <li>Develop creative concepts for digital and print.</li>
                                                    </ul>
                                                    <p className="my-2"><b>Required Skills:</b> Figma, UI/UX, Photoshop, Illustrator, Responsive Design, CorelDRAW, HTML/CSS, Bootstrap.</p>
                                                    <p className="my-2"><b>Good to Have:</b> Canva, Motion graphics / basic video editing, After Effects, Premiere Pro, Branding experience, Print production knowledge, AI-based creative tools.</p>
                                                </Col>
                                                <Col lg={5}>
                                                    <img src={desingerImg} width="100%" alt="designer" />
                                                </Col>

                                            </Row>
                                            <Row className="mt-2">
                                                <div className="d-grid gap-3">
                                                    <Link to="https://docs.google.com/forms/d/e/1FAIpQLSe8bkzSUAY3izWwX-1w5JdXHeL72sPHaY0vsafKcE4dXztdGg/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer" className="btn btn-danger">Apply Now</Link>
                                                </div>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                    
                </Accordion>


                <div className="py-2">
                    <p>If you’re someone who can <b>find opportunities, meet clients, build relationships, and
                        convert them into business</b>, we’d love to hear from you.
                    </p>
                    <p><b>Send Your Resume + Portfolio/LinkedIn Profile</b></p>
                </div>

            </Container>
        </Stack>
    );
}

export default Career;